import Keycloak, { KeycloakLoginOptions } from "keycloak-js";

export class KeycloakService {
  public readonly keycloak: Keycloak.KeycloakInstance;

  private static instancia?: KeycloakService;

  public static get instance() {
    if (KeycloakService.instancia === undefined) {
      KeycloakService.instancia = new KeycloakService();
    }

    return KeycloakService.instancia;
  }

  private constructor() {
    this.keycloak = Keycloak({
      "realm": "UFC",
      "url": process.env.REACT_APP_KEYCLOAK_HOST,
      "clientId": "app-servicos",
    } as any);
  }

  public static readonly LOGIN_OPTIONS: KeycloakLoginOptions = {
    scope: 'id_institucional'
  }
}
